module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-part"
  }, [_c('div', {
    staticClass: "is-clearfix"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'product',
        params: {
          id: _vm.part.product.id
        }
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.part.product.name) + "\n        ")]), _vm._v(" "), (!_vm.editing) ? _c('span', [_vm._v("\n            x " + _vm._s(_vm.part.count) + " " + _vm._s(_vm.part.title ? '-' : '') + " " + _vm._s(_vm.part.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-pulled-right"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }, [_vm._v(_vm._s(_vm.editing ? 'Cancel' : 'Edit'))])])], 1), _vm._v(" "), (_vm.editing) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "field product-field"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('form-control', {
    staticClass: "column is-6",
    attrs: {
      "type": "number",
      "value": _vm.part.count,
      "placeholder": "Count"
    }
  }), _vm._v(" "), _c('form-control', {
    staticClass: "column is-6",
    attrs: {
      "type": "text",
      "value": _vm.part.title,
      "placeholder": "title"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "product-field"
  }, [_c('form-control', {
    attrs: {
      "type": "textarea",
      "value": _vm.part.description,
      "placeholder": "Description"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44dd676b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/ProductPart.vue
// module id = 531
// module chunks = 0